
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import ModelMixin from '@/mixins/ModelMixin';
import LoadableMixin from '@/mixins/LoadableMixin';
import _get from 'lodash.get';
import { DeviceInfo } from '@/types/device-info';
import { Debounce } from '@/modules/decorators';
import { State } from 'vuex-class';
import api from '@/modules/api';
import { UserInfo } from '@/types/user-info';

@Component({
    mixins: [ModelMixin, LoadableMixin],
})
export default class CreateDevicesGroupModel extends Mixins<LoadableMixin, ModelMixin<boolean>>(
    LoadableMixin,
    ModelMixin,
) {
    groupName = '';
    searchDevices: DeviceInfo[] = [];
    selectedDevices: DeviceInfo[] = [];
    devices!: DeviceInfo[];

    @Prop({ type: Function, required: false })
    onRefresh!: () => void;

    @Prop({ required: true })
    title!: string

    @State('user')
    user!: UserInfo;

    @Prop({ required: false })
    editDetails!: any;

    async handleSubmit(e: Event) {
        try {
            e.preventDefault();
            const devicesId: any = this.selectedDevices.map((device) => device._id)
            if (this.title !== 'Create') {
                await api.updateDeviceGroupById(this.editDetails._id, this.groupName, devicesId);
            } else {
                await api.createDeviceGroup(this.groupName, devicesId);
            }
            this.onRefresh();
        } catch (error) {
            console.log('Error', error)
        } finally {
            this.model = false;
        }

    }
    redirectTo(url: string) {
        window.open(url, '_blank');
    }

    async pickDevices(device: any) {
        if (device === null || typeof device === 'string') return;
        if (!this.selectedDevices.some(m => m._id === device._id)) {
            this.selectedDevices.push(device);
        }
    }

    @Debounce(500)
    async searchDevice(name: string) {
        if (!name) return;

        const alreadySelected = this.selectedDevices.find(m => m.name === name);
        if (alreadySelected) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this.$refs.memberSearchElemet as any).lazySearch = '';
            return;
        }
        this.searchDevices = this.devices || [];
    }

    removeDevice(device: any) {
        if (device._id) {
            this.selectedDevices = this.selectedDevices.filter(m => m.name !== device.name);
        }
    }

    @Watch('model', { immediate: true })
    async onModelChnage() {
        this.devices = await api.loadDevices(
            this.user._id as string,
            { page: 0, perPage: 999 },
            '',
            '',
        );
        this.searchDevices = this.devices;
        if (this.title !== 'Create') {
            this.groupName = this.editDetails.name;
            this.selectedDevices = this.editDetails.devices;
        } else {
            this.groupName = '';
            this.selectedDevices = [];
        }
    }
}
